import { useState, useMemo } from 'react'
import { useDebounce } from '@eltoro-ui/hooks'
import { FilterType, SortType } from 'types'

export const useTableSearch = () => {
  const [searchInput, setSearchInput] = useState('')
  const [childOrgsOnly, setChildOrgsOnly] = useState(false)
  const [showArchived, setShowArchived] = useState(false)
  const [searchType, setSearchType] = useState('name')
  const [sort, setSort] = useState<SortType>()
  const [tableFilter, setTableFilter] = useState<FilterType>()
  const debouncedTableFilter = useDebounce(tableFilter, 200)
  const debouncedSearchInput = useDebounce(searchInput, 200)

  const processedSearchInput = useMemo(() => {
    if (searchType === 'tags' && debouncedSearchInput) {
      // Split comma-separated tags and trim whitespace
      return debouncedSearchInput
        .split(',')
        .map((tag) => tag.trim())
        .filter((tag) => tag.length > 0)
    }
    return debouncedSearchInput
  }, [searchType, debouncedSearchInput])

  return {
    searchInput,
    setSearchInput,
    childOrgsOnly,
    setChildOrgsOnly,
    showArchived,
    setShowArchived,
    sort,
    setSort,
    tableFilter,
    setTableFilter,
    debouncedTableFilter,
    debouncedSearchInput,
    processedSearchInput,
    searchType,
    setSearchType,
  } as const
}

export type TableSearchType = {
  searchInput: string
  setSearchInput: React.Dispatch<React.SetStateAction<string>>
  childOrgsOnly: boolean
  setChildOrgsOnly: React.Dispatch<React.SetStateAction<boolean>>
  showArchived: boolean
  setShowArchived: React.Dispatch<React.SetStateAction<boolean>>
  sort?: SortType
  setSort: React.Dispatch<React.SetStateAction<SortType | undefined>>
  tableFilter?: FilterType
  setTableFilter: React.Dispatch<React.SetStateAction<FilterType | undefined>>
  debouncedTableFilter: FilterType | undefined
  debouncedSearchInput: string
  processedSearchInput: string | string[]
  searchType: string
  setSearchType: React.Dispatch<React.SetStateAction<string>>
}
